import { useQuery } from '@tanstack/react-query';
import { getList } from '../../api/metadata.api';
import { metadataKeys } from '../../metadata.keys';
import { HOUR } from '@shared/utils';

export const useGetMetadata = () => {
  return useQuery({
    queryKey: metadataKeys.lists(),
    queryFn: getList,
    staleTime: 1 * HOUR,
    meta: { persist: true },
  });
};
